<div class="modal-content">
    <div class="header">
        <h3>Edit Notification</h3>
        <img src="assets/icons/close-sm.svg" alt="" (click)="modal.deny(undefined)">
    </div>

    <div class="content" [formGroup]="editForm">
        <div class="field">
            <span>Notification Name</span>
            <input type="text" formControlName="notificationName">
        </div>

        <div class="field">
            <span>Email</span>
            <input type="text" formControlName="email">
        </div>

        <div class="field">
            <span>Subject</span>
            <input type="text" formControlName="subject">
        </div>

        <div class="field">
            <span>Description</span>
            <textarea name="" id="" formControlName="description"></textarea>
        </div>

        <button class="send-test">Send Test Notification</button>
    </div>

    <div class="ctrl-btns">
        <button class="cancel" (click)="modal.deny(undefined)">Cancel</button>
        <button class="save" [disabled]="editForm.invalid">Save</button>
    </div>
</div>